import { Check, Save } from "lucide-react";

export interface BottomActionBarProps {
  isSaving: boolean;
  isDirty: boolean;
  savedOk: boolean;
  onDiscard: () => void;
  onSave: () => void;
}

export default function BottomActionBar({
  isSaving,
  isDirty,
  savedOk,
  onDiscard,
  onSave,
}: BottomActionBarProps) {
  return (
    <div className="sticky bottom-0 left-0 right-0 bg-white border-t border-gray-100 shadow-[0_-4px_24px_rgba(0,0,0,0.06)] z-20">
      <div className="max-w-full px-8 py-4 flex items-center justify-end gap-4">

        {/* Discard */}
        <button
          onClick={onDiscard}
          disabled={!isDirty}
          className="px-5 py-2.5 text-sm font-semibold text-gray-600 bg-gray-100 hover:bg-gray-200 disabled:opacity-40 disabled:cursor-not-allowed rounded-xl transition-colors"
        >
          Discard Changes
        </button>

        {/* Save & Deploy */}
        <button
          onClick={onSave}
          disabled={isSaving || !isDirty}
          className="flex items-center gap-2 px-6 py-2.5 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-bold rounded-xl transition-colors shadow-sm shadow-indigo-200"
        >
          {isSaving ? (
            <>
              <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
              Saving...
            </>
          ) : savedOk ? (
            <>
              <Check size={14} />
              Deployed!
            </>
          ) : (
            <>
              <Save size={14} />
              Save &amp; Deploy Rules
            </>
          )}
        </button>
      </div>
    </div>
  );
}
